// Packages
import { Component } from "react";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Assets
import ReactPlayer from "react-player";
import moment from "moment";
// Services
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import GameCard from "../../Common/GameCard";
import { FaRegClock } from "react-icons/fa";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class schoolAdminFeed extends Component {
  state = {
    anchorEl: null,
    schoolId: "",
    liveGameDashboardResponses: [],
    recentGameDashboardResponses: [],
    upcommingGameDashboardResponses: [],
    liveGameDashboardResponsesFlag: false,
    recentGameDashboardResponsesFlag: false,
    upcommingGameDashboardResponsesFlag: false,
    shareMediaDetailsResponses: [],
    checkBackId: null,
    submitting: false,
    schoolLogo: null,
    schoolName: "",
    trendingFlag: true,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  componentDidMount() {
    const feed = document.getElementById("Trending");
    if (feed) {
      feed.classList.add("btnActive");
    }
    var schoolId = getFromLocalStorage("schoolId");
    const schoolName = getFromLocalStorage("schoolName");
    var schoolLogo = getFromLocalStorage("schoolLogo");
    this.setState({ schoolId, schoolLogo, schoolName });
    this.getTrendingData(schoolId);
    this.getSchoolFeed(schoolId);
  }

  getSchoolFeed(schoolId) {
    this.setState({
      submitting: true,
    });
    userService
      .getSchoolAdminDashboardData(schoolId)
      .then((response) => {
        var liveGameDashboardResponses =
          response.data.data.liveGameDashboardResponses;
        var recentGameDashboardResponses =
          response.data.data.recentGameDashboardResponses;
        var upcommingGameDashboardResponses =
          response.data.data.upcommingGameDashboardResponses;
        if (liveGameDashboardResponses.length != 0) {
          var liveGameDashboardResponsesFlag = true;
          this.setState({ liveGameDashboardResponsesFlag });
        }
        if (recentGameDashboardResponses.length != 0) {
          var recentGameDashboardResponsesFlag = true;
          this.setState({ recentGameDashboardResponsesFlag });
        }
        if (upcommingGameDashboardResponses.length != 0) {
          var upcommingGameDashboardResponsesFlag = true;
          this.setState({ upcommingGameDashboardResponsesFlag });
        }
        this.setState({
          recentGameDashboardResponses,
          upcommingGameDashboardResponses,
          liveGameDashboardResponses,
        });
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.setState({
          submitting: false,
        });
      });
  }

  getTrendingData(schoolId) {
    userService.getTrendingDetails(schoolId).then((res) => {
      var shareMediaDetailsResponses = res.data.data.shareMediaDetailsResponses;
      let trendingFlag = true;
      if (shareMediaDetailsResponses.length !== 0) {
        trendingFlag = false;
      }
      this.setState({ shareMediaDetailsResponses, trendingFlag }, () =>
        this.setState({ submitting: false })
      );
    });
  }

  postTrendingCount(id) {
    const { checkBackId, schoolId } = this.state;
    if (checkBackId != id) {
      var isViews = true;
      userService.trendingViewPost(isViews, id).then((res) => {
        this.getTrendingData(schoolId);
        var checkBackId = id;
        this.setState({ checkBackId });
      });
    }
  }

  tConvert = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? "AM" : "PM";
      time[0] = +time[0] % 12 || 12;
    }
    let timeformat = time.join("");
    if (timeformat.length == 10) {
      timeformat = timeformat.slice(0, 5) + " " + timeformat.slice(8, 10);
    } else {
      timeformat = timeformat.slice(0, 4) + " " + timeformat.slice(7, 9);
    }
    return timeformat;
  };

  dConvert = (d) => {
    var date = new Date(moment(d).format());
    date =
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear();
    return date;
  };

  render() {
    const {
      recentGameDashboardResponses,
      upcommingGameDashboardResponses,
      liveGameDashboardResponses,
      shareMediaDetailsResponses,
      trendingFlag,
      submitting,
    } = this.state;
    const { isDrawerOpen } = this.props;
    return (
      <div className={submitting ? "gray-out" : " "}>
        <SchoolAdminDashboard />
        <div
          // className="content-layout"
          className={
            isDrawerOpen ? "content-layout" : "toggle-content-layout p-2"
          }
        >
          <div className="row mrtopRes">
            <div className="col-12 col-sm-12 col-md-7 col-lg-8 ">
              <div className="plpr-4">
                <h2 className="fs-28 bold black mobofs36 pb-2">Trending</h2>
                <div className="clear10"></div>
                {shareMediaDetailsResponses.length > 0 &&
                  shareMediaDetailsResponses.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 col-sm-12 col-md-12 col-lg-12 main-card-box"
                    >
                      <div className="row">
                        <div
                          className="col-12 col-md-12 col-lg-3 px-2 py-2"
                          id="trending_vido"
                        >
                          <ReactPlayer
                            id="videoPlayer"
                            url={item.eventMedia.videoPath}
                            playing={false}
                            controls
                            onClick={() =>
                              this.postTrendingCount(item.shareMediaId)
                            }
                          />
                        </div>
                        <div className=" col-12 col-md-12 col-lg-9 px-2 pt-2 pb-3">
                          <div className="clear10"></div>
                          <p className="fs-18 semi-bold dblack">
                            {item.school1Name} vs. {item.school2Name} |{" "}
                            {item.videoTitle}
                          </p>
                          <div className="clear10"></div>
                          <span className="fs-14 medium colorb4">
                            {item.trendingViewsCount} views
                          </span>
                          &nbsp;<div className="greydot disin"></div>&nbsp;
                          <span className="fs-14 medium colorb4">
                            {item.lastSeen}
                          </span>
                          <div className="clear10"></div>
                          <p className="fs-16 medium">
                            {item.videoDescription}
                            <span className="dblue cp"></span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                {trendingFlag && submitting == false && (
                  <div className="row">
                    <div className="col-lg-12 mg-top-10">
                      <p className="nodatabox">
                        No feed available currently. Once you or your Coaches,
                        Athletes share the content, it will become available
                        here
                      </p>
                    </div>
                  </div>
                )}
                <div className="clear20"></div>
                <div className="clear20"></div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-5 col-lg-4">
              <GameCard
                gameList={liveGameDashboardResponses}
                title="Live Games"
                icon={<FaRegClock className="fs-20 text-danger" />}
              />
              <GameCard
                gameList={upcommingGameDashboardResponses}
                title="Upcoming Games"
                icon={<FaRegClock className="fs-20 green" />}
              />
              <GameCard
                gameList={recentGameDashboardResponses}
                title="Recent Games"
                icon={<FaRegClock className="fs-20 text-warning" />}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(connect(mapStateToProps)(schoolAdminFeed));

// export default schoolAdminFeed;
